












import Vue from "vue";
import { config } from "@/config";

export default Vue.extend({
  name: "About",
  data() {
    return {
      version: config.version,
    };
  },
  computed: {
    year(): number {
      return new Date().getFullYear();
    },
  },
});
